import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';

import { ApiMsService, ApiMsServices } from '../../_core/services/api-ms.service';
import { GlobalService } from '../../_core/services/global.service';
import { RequestPermissionService } from '../../request/request-permission.service';

import { UserProfileModel } from './models/user-profile.model';

import { RetailerModel } from 'app/_core/models/retailer.model';
import { ProfileService } from 'app/_core/services/profile.service';
import { RetailerService } from 'app/_core/services/retailer.service';

@Injectable()
export class UserCreateEditService extends GlobalService {
  public permissions: string[] = ['create_user', 'edit_user'];

  public constructor(
    protected _http: HttpClient,
    private readonly apiMsService: ApiMsService,
    private readonly retailerService: RetailerService,
    private readonly profileService: ProfileService,
    private readonly requestPermissionService: RequestPermissionService
  ) {
    super(_http);
  }

  public getInitialData(): Observable<any> {
    return forkJoin({
      retailers: this.getRetailers(),
      profiles: this.getProfiles(),
      permissions: this.requestPermissionService.getRequestPermissions(),
    });
  }

  public getUser(userId: string): Observable<any> {
    return this.apiMsService.call<any>(ApiMsServices.Comercializadores, `user/get`, {
      filters: { userUniqueCode: userId },
    });
  }

  /**
   * Gets the list of all retailers
   */
  public getRetailers(): Observable<RetailerModel[]> {
    return this.retailerService.getRetailers();
  }

  public getProfiles(): Observable<UserProfileModel[]> {
    return this.profileService.getAll();
  }

  public save$(data: any): Observable<any> {
    const args = {
      name: data.curUserName,
      email: data.curUserEmail,
      phone: data.curUserPhone,
      position: data.curUserPosition,
      assignable: data.curUserAssignable,
      profile: data.curUserProfile,
      permissions: data.permissions,
      requestPermissions: data.requestPermissions,
    };
    if (data['curUserUniqueCode']) {
      args['userUniqueCode'] = data.curUserUniqueCode;

      return this.apiMsService.call<any>(ApiMsServices.Comercializadores, `user/update`, { user: args });
    }
    args['retailerUniqueCode'] = data['curUserRetailerUniqueCode'];
    args['account'] = data['curUserUsername'];

    return this.apiMsService.call<any>(ApiMsServices.Comercializadores, `user/create`, { user: args });
  }
}
